/** @jsx jsx */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';
import { useSelector } from 'react-redux';

import {
  challengesStatusSelector,
  historySelectedChallengeSelector,
  sortedDeclaredChallengesSelector,
} from 'reducers/challenge.reducer';
import ActionsHeading from '../sharedComponents/ActionsHeading';
import ErrorView from 'components/ErrorView';
import downArrow from 'assets/icons/downArrow.svg';
import { LOADING_STATUS } from 'constants/index';
import Header from '../sharedComponents/Header';
import Declarations from '../sharedComponents/Declarations';
import { productCurrencySelector } from 'reducers/app.reducer';
import Footer from './Footer';
import List from '../sharedComponents/ActionList/List';

const HistoryContentMobile = (): JSX.Element => {
  const { t } = useTranslation();

  const declaredChallenges = useSelector(sortedDeclaredChallengesSelector);
  const declaredChallengesLoadingStatus = useSelector(challengesStatusSelector);
  const isChallengesOnResolvedStatus =
    declaredChallengesLoadingStatus === LOADING_STATUS.RESOLVED;
  const historySelectedChallengeData = useSelector(
    historySelectedChallengeSelector,
  );
  const hasDeclaredChallenges =
    isChallengesOnResolvedStatus && !!declaredChallenges.length;

  const rewardUnit = useSelector(productCurrencySelector);
  const resultUnit = 'RESULT UNIT';
  // TODO: use getResultUnit si on me donne challengeGoal en unit
  // if isGoalMecanicByProduct is true we have to display the potential rewards to be gained
  // in other cases, we have to display the results to be gained
  const isGoalMecanicByProduct =
    !historySelectedChallengeData?.data?.isRewardingGlobal;
  const unitToDisplay = isGoalMecanicByProduct ? rewardUnit : resultUnit;

  const isDeclarationAvailable =
    historySelectedChallengeData?.data?.isActionOnGoing &&
    (historySelectedChallengeData?.data?.isDeclarationMultiple ||
      (!historySelectedChallengeData?.data?.countDeclarationsWaiting &&
        !historySelectedChallengeData?.data?.countDeclarationsValidated));

  // manage the 'no existing url id' state = 'not in declared challenges list' state
  // and manage the 'is existing url id' state
  // and manage the 'no url id' state
  // '/history/notExistingUrl'
  // '/history/isExistingUrl'
  // '/history'
  return (
    <section style={{ padding: '16px 32px' }}>
      {historySelectedChallengeData?.selectedChallengeId &&
        !historySelectedChallengeData.isInDeclaredChallengesList && (
          <ErrorView
            errorText={t('challenges.declaration.history.link_does_not_exist')}
            actionText={t('challenges.declaration.history.action_choice')}
            mobileImage={downArrow}
            isMobile
          />
        )}
      <ActionsHeading />
      {historySelectedChallengeData?.data && hasDeclaredChallenges ? (
        <React.Fragment>
          <Header
            action={historySelectedChallengeData.data}
            isDeclarationAvailable={isDeclarationAvailable}
          />
          {historySelectedChallengeData.data?.declarations && (
            <Declarations
              declarations={historySelectedChallengeData.data?.declarations}
              unitToDisplay={unitToDisplay}
              isGoalMecanicByProduct={isGoalMecanicByProduct}
            />
          )}
        </React.Fragment>
      ) : (
        <List />
      )}
      {isDeclarationAvailable &&
        historySelectedChallengeData?.selectedChallengeId && (
          <Footer id={+historySelectedChallengeData.selectedChallengeId} />
        )}
    </section>
  );
};

export default HistoryContentMobile;
